// @ai-generated 2026-09-03T18:30:00+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)

/**
 * The rule tree is stored in a `jsonb` column, so what comes back from the server is normalised
 * rather than laid out — a single line that is unpleasant to edit.
 */

/** Lays the AST out for editing. */
export function prettyPrintAst(astJson: string): string {
    if (!astJson) {
        return '';
    }

    try {
        return JSON.stringify(JSON.parse(astJson), null, 2);
    } catch {
        return astJson;
    }
}

/** Strips the layout back out, which is the shape the column stores. */
export function compactAst(astJson: string): string {
    if (!astJson) {
        return '';
    }

    try {
        return JSON.stringify(JSON.parse(astJson));
    } catch {
        return astJson;
    }
}

/**
 * Whether two payloads carry the same rules, ignoring layout. Used to tell a real edit from the
 * round trip through {@link prettyPrintAst}: `jsonb` has its own spacing, so the text the server
 * returns never matches the text `JSON.stringify` produces, and comparing raw would report every
 * visit to the editor as a change.
 */
export function isSameAst(left: string, right: string): boolean {
    return compactAst(left) === compactAst(right);
}
